
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiKitesurfing as ObiKitesurfingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-kitesurfing.js';
 
 
 

 
 export const ObiKitesurfing = createComponent({
   react: React,
   tagName: 'obi-kitesurfing',
   elementClass: ObiKitesurfingElement,
   events: {
     
   }
  });
 
 